module.exports = __webpack_public_path__ + "img/0.e8066fc8.svg";